import React from 'react';

export const Hero = () => (
  <div className="lg:grid lg:grid-cols-2 lg:gap-16 lg:items-center lg:pt-2">
    <div className="lg:max-w-[32rem]">
      <h2 className="text-[#006EB7] font-semibold text-base md:text-xl mb-3 mt-4 lg:mt-0">
        Calculators
      </h2>

      <h1 className="text-4xl md:text-5xl lg:text-4xl xl:text-5xl text-[#0C0D1A] font-semibold mb-6 md:w-[40rem] lg:w-auto">
        Annual Overpayments and ERC Calculator
      </h1>

      <p className="text-base text-[#373945] font-450 mb-6">
        To help illustrate the benefits of making optional lifetime mortgage payments.
      </p>
      <p className="text-base text-[#373945] font-450 mb-6">
        We have created an annual overpayments and ERC calculator to make it easier for you and your clients.
      </p>
      <p className="text-base text-[#373945] font-450 mb-8 lg:mb-0">
        Enter the property value, loan size, interest rate, and when your client wants to repay, and the calculator will demonstrate the impact of the payments on the balance, the remaining equity and whether any ERCs are applicable.
      </p>
    </div>

    <div className="w-full">
      {/* Image Container */}
      <div className="w-full rounded-lg overflow-hidden">
        <img
          src="/img/adviser/resources/lifetime-mortgage-calculators/annual-overpayments-and-erc-calculator/hero.webp"
          alt="customer support tools"
          loading="eager"
          className="w-full object-cover rounded-xl lg:h-[30.5rem]"
        />
      </div>
    </div>
  </div>
);
